import styled from "@emotion/styled";
import { Box, Chip, FormHelperText, FormLabel } from "@mui/material";
import { shouldForwardProp } from "../../../../common/Common.style";
import theme from "../../../../theme";

type ChipSelectedProp = {
  isSelected: boolean;
};

export const VisitsLabel = styled(FormLabel)`
  font-size: 14px;
`;

export const VisitsWrapper = styled(Box)`
  padding-top: 16px;
  padding-bottom: 24px;
`;

export const VisitsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  gap: 8px;
`;

export const VisitItem = styled(Chip, {
  shouldForwardProp: prop =>
    shouldForwardProp<ChipSelectedProp>(["isSelected"], prop),
})<ChipSelectedProp>(({ isSelected }) => ({
  backgroundColor: isSelected
    ? theme.palette.primary.main
    : theme.palette.common.white,
  color: isSelected ? theme.palette.common.white : theme.palette.primary.main,
  border: `1px solid ${isSelected ? theme.palette.primary.main : theme.palette.grey[400]}`,
  borderRadius: 4,
  padding: "16px 8px",
  "&:hover": {
    background: isSelected
      ? theme.palette.primary.main
      : `${theme.palette.primary.main}15`,
  },
}));

export const ErrorText = styled(FormHelperText)`
  color: ${theme.palette.error.main};
`;
